export enum GPSFixStatus {
  NoFix = -1,
  SinglePointPositioning = 0,
  SatelliteBasedAugmentationSystem = 1,
  DifferentialGPS = 2,
  RTKFloat = 3,
  RTKFix = 4
}
